export { default } from './MilitaryRankThree'
